var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 16,
    rx: 3,
    fill: "#F5F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15.5L10 8.5H11.8L14.8 15.5H13.1L12.5 14H9.3L8.7 15.5H7ZM9.85 12.6H11.95L10.9 9.95L9.85 12.6Z",
    fill: "#1677FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 15.5V8.5H17.9C20.05 8.5 21.25 9.82 21.25 12C21.25 14.18 20.05 15.5 17.9 15.5H15.3ZM16.9 14.05H17.8C18.98 14.05 19.62 13.32 19.62 12C19.62 10.68 18.98 9.95 17.8 9.95H16.9V14.05Z",
    fill: "#0A66C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 19.5L18.5 6.5",
    stroke: "#34A33B",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 5.75H18.25",
    stroke: "#AAC3EE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 18.25H18.25",
    stroke: "#AAC3EE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsChecker);
export default __webpack_public_path__ + "static/media/ads-checker.811e3a2c890437fd1d7ca9eb211016c0.svg";
export { ForwardRef as ReactComponent };